import { type DetailedHTMLProps, type HTMLAttributes, useState } from "react"

import { cn } from "#app/utils/misc"

export default function LoaderImage({
	src,
	alt,
	...props
}: {
	alt: string
	src: string
} & DetailedHTMLProps<HTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
	const [isLoading, setLoading] = useState(true)

	return (
		<div
			className={cn(
				"relative aspect-square w-full overflow-hidden rounded-lg bg-gray-200",
				props.className,
			)}
		>
			<img
				alt={alt}
				src={src}
				className={cn(
					"h-full w-full duration-700 ease-in-out group-hover:opacity-75",
					isLoading
						? "scale-110 blur-2xl grayscale"
						: "scale-100 blur-0 grayscale-0",
				)}
				onLoad={() => setLoading(false)}
				sizes="100vw"
				style={{
					objectFit: "cover",
					objectPosition: "center",
				}}
			/>
		</div>
	)
}
